module.exports = __webpack_public_path__ + "static/media/19ESCAP30.e1b89f51.jpg";